'use strict';

const reassurances = require('core/product/reassurances');
const processInclude = require('base/util');
require('core/components/spinner');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('core/product/fitguide'));
    processInclude(require('core/product/notifyWhenAvailable'));
    processInclude(require('./tealium/tealiumEvents'));
    reassurances.copyID();
});
